import * as ActionUtility from '@utilities/action-utility'

const SET_SECURITY_FIELD = 'Aberto.Onboarding.SET_SECURITY_FIELD'

const setSecurityField = (name, value) => {
  return ActionUtility.createAction(SET_SECURITY_FIELD, { name, value })
}

export { setSecurityField, SET_SECURITY_FIELD }
